import React from "react";
import { getVaultDocumentTitle } from "./qmsVaultUtils";

function QmsVaultCheckoutReasonModal({
  open,
  row,
  loading = false,
  details = null,
  onClose,
}) {
  if (!open || !row) return null;

  const reason = String(details?.reason || "").trim();
  const checkedOutBy = String(details?.checkedOutBy || "").trim();
  const checkedOutAt = String(details?.checkedOutAt || "").trim();

  return (
    <>
      <div
        className="modal fade show d-block qms-vault-checkout-reason-modal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Checkout reason</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
                disabled={loading}
              />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <div className="text-muted small">Document</div>
                <div className="fw-semibold">{getVaultDocumentTitle(row)}</div>
              </div>

              {loading ? (
                <p className="text-muted mb-0">Loading checkout details…</p>
              ) : (
                <>
                  {(checkedOutBy || checkedOutAt) && (
                    <dl className="qms-vault-checkout-reason__meta mb-3">
                      {checkedOutBy ? (
                        <>
                          <dt>Checked out by</dt>
                          <dd>{checkedOutBy}</dd>
                        </>
                      ) : null}
                      {checkedOutAt ? (
                        <>
                          <dt>Checked out on</dt>
                          <dd>{checkedOutAt}</dd>
                        </>
                      ) : null}
                    </dl>
                  )}

                  <div>
                    <div className="text-muted small mb-1">Reason</div>
                    <div className="qms-vault-checkout-reason__text">
                      {reason || "No reason was provided for this checkout."}
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={onClose}
                disabled={loading}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
}

export default QmsVaultCheckoutReasonModal;
